import { atlas } from 'graphql/tags'

export const GET_NEW_INVITATIONS_COUNT = atlas`
  query NewInvitationCount {
    newInvitationCount {
      count
    }
  }
`
